import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { useBox } from "../../../Finanzas/Helper/useBox";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CommentIcon from '@mui/icons-material/Comment';

import EditIcon from '@mui/icons-material/Edit';
import { FiltroRotacionCXC } from "./FiltroRotacionCXC";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useBoxProyecciones } from "../ProyeccionesVentas/useBoxProyecciones";

export const RotacionCXCSucursalScreen = () => {
    const history = useHistory();
    const location = useLocation();

    const idlinea = location.state?.idlinea || 0;
    const sucursales = location.state?.sucursales;
    const sucursalesSeleccionadas = location.state?.sucursalesSeleccionadas || 0;

    const [boxstate, setBoxState, updateBoxState] = useBoxProyecciones();
    const [inventario, setInventario] = useState();
    const [editarGuia, setEditarGuia] = useState(false);
    const [totales, setTotales] = useState();
    const [titulo, setTitulo] = useState("ROTACION CXC");


    const meses = [
        "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
        "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];


    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        const today = new Date();
        let currentMonth = today.getMonth() + 1;
        let currentYear = today.getFullYear();

        onIniciar(currentYear, currentMonth, sucursalesSeleccionadas);

    }, []);


    const onIniciar = (
        ejercicio,
        periodo,
        sucursal
    ) => {

        setLoader({ ...loader, mostrar: true });


        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `RotacionCXC/ReporteSucursal?ejercicio=${ejercicio}&periodo=${periodo}&adr=${0}&sucursales=${sucursal}&departamentos=${idlinea}&tipoReporte=S`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });

                    // const filasBody = result.filter(
                    //     item => item.linea !== "TOTALES" && item.linea !== "ROTACION TOTAL"
                    // );

                    // const totales = result.find(item => item.linea === "TOTALES");
                    // const rotacionTotal = result.find(item => item.linea === "ROTACION TOTAL");

                    setInventario(result);
                    // setTotales(totales);
                    // setRotacion(rotacionTotal);
                    setEditarGuia(result.editor_guia)

                    const mesFinalIndex = periodo - 1;      // periodo: 1–12
                    const mesFinal = meses[mesFinalIndex];
                    const anioFinal = ejercicio;

                    const mesInicialIndex = (mesFinalIndex + 1) % 12;
                    const mesInicial = meses[mesInicialIndex];
                    const anioInicial = ejercicio - 1;

                    const tituloP = `ROTACION CXC ${mesFinal} ${anioFinal}`;

                    setTitulo(tituloP)

                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };
    console.log(boxstate)
    const onExecute = (
    ) => {

        setLoader({ ...loader, mostrar: true });
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        var departamento = GetKey(boxstate.pv.departamento, ["iddepartamento"]);


        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }

        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `RotacionCXC/ReporteSucursal?ejercicio=${boxstate.ejercicioinicio}&periodo=${boxstate.periodofin}&adr=${adr}&sucursales=${sucursales}&departamentos=${departamento === "" ? idlinea : departamento}&tipoReporte=S`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });

                    // const filasBody = result.filter(
                    //     item => item.linea !== "TOTALES" && item.linea !== "ROTACION TOTAL"
                    // );

                    // const totales = result.find(item => item.linea === "TOTALES");
                    // const rotacionTotal = result.find(item => item.linea === "ROTACION TOTAL");

                    setInventario(result);
                    // setTotales(totales);
                    // setRotacion(rotacionTotal);
                    setEditarGuia(result.editor_guia)

                    const mesFinalIndex = boxstate.periodofin - 1;      // periodo: 1–12
                    const mesFinal = meses[mesFinalIndex];
                    const anioFinal = boxstate.ejercicioinicio;

                    const mesInicialIndex = (mesFinalIndex + 1) % 12;
                    const mesInicial = meses[mesInicialIndex];
                    const anioInicial = boxstate.ejercicioinicio - 1;

                    const tituloP = `ROTACION CXC ${mesFinal} ${anioFinal}`;

                    setTitulo(tituloP)

                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    const onRegresar = () => {
        history.push("/Finanzas/Main");
    };

    const onDetalle = (idsucursal) => {
        history.push("/Finanzas/RotacionCXC", {
            sucursalesSeleccionadas: idsucursal,
            sucursales: sucursales
        });
    };

    const onGeneraExcel = (
    ) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }

        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `RotacionInventario/ImprimirExcelReporte?ejercicio=${Number(boxstate.ejercicioinicio)}&periodo=${Number(boxstate.periodoinicio)}&adr=${adr}&sucursales=${sucursales}`
            )
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
            });
    };


    const inventarioAgrupado = inventario?.reduce((acc, item) => {
        if (!acc[item.estado]) {
            acc[item.estado] = [];
        }
        acc[item.estado].push(item);
        return acc;
    }, {});

    return (
        <PlantillaScreen
            titulo={titulo}
            className={"rotacion-cxc-main-screen"}
            className_main={2}
        >
            <LoaderScreen loader={loader} />

            <div className="rotacion-cxc-actions">
                <div
                    className="reporte-recuperacion-responsable-actions-regresar"
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="reporte-recuperacion-responsable-actions-filtro">
                    <FiltroRotacionCXC
                        onBoxChange={setBoxState}
                        boxState={boxstate}
                        BoxClick={onExecute}
                        updateBoxState={updateBoxState}
                        titulo_filtro={"FILTRO ROTACION CXC"}
                        // titulo='Estado de Resultados Comparativo real vs proyeccion'
                        // subtitulo={SubTitulo()}
                        extrayear={3}
                        sucursales={sucursales}
                    />
                </div>
                <div className="buttons">

                    {/* <button className="excel"
                        onClick={() => onGeneraExcel()}
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button> */}
                </div>
            </div>

            {
                inventario && inventario.length > 0 && (
                    <div className="inventario-rotacion-main-container">
                        <div className="rotacion-cxc-tabla-container scroll">
                            <table cellPadding={0} cellSpacing={0}>
                                <thead>
                                    <tr>
                                        <th>
                                            sucursal
                                        </th>
                                        <th>
                                            <div>Saldo Inicial</div>
                                        </th>
                                        <th>
                                            <div>Movimiento</div>
                                        </th>
                                        <th>
                                            <div>Saldo Final</div>
                                        </th>
                                        <th>
                                            <div>Rotacion</div>
                                        </th>
                                        <th>
                                            <div>Guia</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Usar map para renderizar las filas de la tabla */}
                                    {inventarioAgrupado &&
                                        Object.keys(inventarioAgrupado).map((estado, i) => (
                                            <React.Fragment key={i}>
                                                {/* 🔸 Fila separadora por estado */}
                                                <tr className="fila-estado">
                                                    <td colSpan={6}>
                                                        {estado}
                                                    </td>
                                                </tr>

                                                {/* 🔸 Filas de sucursales */}
                                                {inventarioAgrupado[estado].map((item, index) => (
                                                    <tr
                                                        className="grupo-header"
                                                        key={index}
                                                        onClick={() => onDetalle(item.idsucursal)}
                                                    >
                                                        <td className="celda-vendedor">
                                                            {capitalizePalabras(item.sucursal)}
                                                        </td>
                                                        <td className="ta-right">{FormatMoney(item.saldo_inicial, 0)}</td>
                                                        <td className="ta-right">{FormatMoney(item.credito, 0)}</td>
                                                        <td className="ta-right">{FormatMoney(item.saldo_final, 0)}</td>
                                                        <td className="ta-center">{FormatMoney(item.rcxc, 2)}</td>
                                                        <td className="ta-center">{item.guia}</td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                </tbody>
                                <tfoot>
                                    {totales && (
                                        <tr>
                                            <td className="celda-vendedor">{capitalizePalabras(totales.sucursal)}</td>
                                            <td className="ta-right">{FormatMoney(totales.saldo_inicial, 0)}</td>
                                            <td className="ta-right">{FormatMoney(totales.credito, 0)}</td>
                                            <td className="ta-right">{FormatMoney(totales.saldo_final, 0)}</td>
                                            <td className="ta-center">{totales.rcxc}</td>
                                            <td className="ta-center">{totales.guia}</td>
                                        </tr>
                                    )}

                                </tfoot>

                            </table>
                        </div>
                    </div >
                )
            }
        </PlantillaScreen >
    );
};
